// extracted by mini-css-extract-plugin
module.exports = {"content":"Page-module__content___196kn","banner":"Page-module__banner___1Q6JX","padded":"Page-module__padded___3hQ0U","mismatchModal":"Page-module__mismatchModal___1NikF"};